// extracted by mini-css-extract-plugin
export default {"title1":"faq_title1__-sCtW","link":"faq_link__B9zi3","title2":"faq_title2__5RW0o","content":"faq_content__FsSNS"};